import { render, staticRenderFns } from "./CohortsEdit.vue?vue&type=template&id=3a05eb8c&scoped=true&"
import script from "./CohortsEdit.vue?vue&type=script&lang=js&"
export * from "./CohortsEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a05eb8c",
  null
  
)

export default component.exports